"use client"

import HeroSection from "@/components/contact/hero-section";
import ContactFormSection from "@/components/contact/contact-form-section";
import FAQSection from "@/components/shared/faq-section";
import CTABannerSection from "@/components/shared/cta-banner-section";

export default function ContactPageView() {
  return (
    <main>
      <HeroSection />
      <ContactFormSection />
      <FAQSection />
      <CTABannerSection />
    </main>
  );
}
